<template>
  <div v-if="getCollections" class="catalog-section-menu">
    <div class="catalog-section-menu__items">
      <div v-for="collection in getItems" :key="collection.href" class="catalog-section-menu__item">
        <a :href="collection.href" class="catalog-section-menu__link">
          {{ collection.name }}
        </a>
        <span v-if="collection.new" class="catalog-section-menu__new">
          {{ collection.new }}
        </span>
      </div>
    </div>
    <DefShowMore v-if="screenWidth < 992" v-model="isShowMore">
      <template #less>{{ messages.less }}</template>
      {{ messages.more }}
    </DefShowMore>
  </div>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
import DefShowMore from '@components/Def/DefShowMore/DefShowMore.vue';
import { ref, computed } from 'vue';
import { useResultsStore } from '@/storePinia/stores/results';

const screenWidth = useScreenWidth();
const resultsStore = useResultsStore();

const isShowMore = ref(false);

const messages = computed(() => resultsStore.messages);
const mainMenu = computed(() => resultsStore.menus.mainMenu);

const getCollections = computed(() =>
  mainMenu.value?.items?.find((el) => el?.isCollection)?.items?.filter((el) => !!el.elementCnt)
);

const getItems = computed(() => {
  try {
    if (screenWidth.value >= 992 || isShowMore.value) {
      return getCollections.value;
    }

    if (screenWidth.value >= 768 && getCollections.value && getCollections.value.length >= 16) {
      return getCollections.value?.slice(0, 16);
    }
    if (screenWidth.value < 768 && getCollections.value && getCollections.value.length >= 8) {
      return getCollections.value?.slice(0, 8);
    }
  } catch (err) {
    console.error(err);
  }
  return getCollections.value;
});
</script>

<style lang="scss" scoped>
.catalog-section-menu {
  background-color: #e3f0f7;
  padding: 16px;
  margin-bottom: 24px;
  @include point-md {
    padding: 32px 24px;
  }
  &__items {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 16px;
    @include point-md {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @include point-lg {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
  }
  &__link {
    text-decoration: underline;
    text-decoration-color: transparent;
    transition: text-decoration-color 200ms ease;
    text-underline-position: under;
    &:hover {
      text-decoration-color: currentColor;
    }
  }
  &__new {
    margin-left: 8px;
    background-color: #b8ccec;
    padding: 2px 4px;
  }
  :deep(.def-show-more) {
    margin-top: 24px;
    @include point-md {
      margin-top: 24px;
    }
  }
}
</style>
